import { useState } from 'react';

type AnswersType = {
  question1: string | null;
  question2: string | null;
};

const useRegisterTermOfAdhesion = () => {
  const [activeStep, setActiveStep] = useState<number>(0);

  const handleNext = (newAnswers?: AnswersType) => {
    setActiveStep((prevStep) => prevStep + 1);
  };

  const handlePrev = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const steps = ['Dados principais', 'Confirmação dos Dados'];

  return {
    activeStep,
    steps,
    handleNext,
    handlePrev,
  };
};

export default useRegisterTermOfAdhesion;
